import { useRouter } from "next/router";
import { skipToken } from "@tanstack/react-query";
import { CONTRACTOR_MSA_ROUTE } from "@remi/constants";
import { OrganizationType } from "@remi/enums/organization-type";
import { RnHazard } from "@remi/icons/next";
import { formatString, strings } from "@remi/localization";
import { RemiButton } from "@remi/next-ui";
import { can } from "@remi/permissions";

import { api } from "~/utils/api";
import { useUserProfile } from "~/contexts/UserProfileContext";

export const MsaResignBanner = () => {
  const router = useRouter();
  const { user } = useUserProfile();
  const organizationId = user.person.organizationId;
  const isSigner =
    user.person.organization.type === OrganizationType.CONTRACTOR && can.dropboxSign.create(user, organizationId);
  const isOnMsaPage = router.pathname === CONTRACTOR_MSA_ROUTE;
  const { data } = api.contractorOnboarding.getMsaResignStatus.useQuery(
    isSigner && !isOnMsaPage ? { contractorProfileId: organizationId } : skipToken,
  );

  if (!isSigner || isOnMsaPage || data === undefined || data.state === "NOT_DUE") {
    return null;
  }

  const copy = strings.shared.msaResignBanner;
  const description =
    data.state === "OVERDUE"
      ? copy.overdue
      : formatString(copy.due, {
          date: data.dueAt?.toLocaleDateString("en-US", { month: "long", day: "numeric" }) ?? "",
        });

  return (
    <div
      role="status"
      className="flex w-full items-center justify-between gap-4 border-border-accent border-b-[1px] bg-background-accentLight p-4"
    >
      <div className="flex items-center">
        <RnHazard className="shrink-0 text-icon-primary" />
        <p className="ml-3 text-text-primary text-xs">{description}</p>
      </div>
      <RemiButton
        variant="primary"
        size="md"
        appearance="pill"
        className="shrink-0"
        onClick={() => void router.push(CONTRACTOR_MSA_ROUTE)}
      >
        {copy.action}
      </RemiButton>
    </div>
  );
};
